"use client";
import { useRouter, usePathname } from "next/navigation";
import { useMemo } from "react";
import { motion } from "framer-motion";

export default function Filters({ blogs }) {
  const router = useRouter();
  const pathname = usePathname();

  // Derive selected category directly from the URL
  const selectedCategory =
    pathname === "/blog" ? "all" : pathname.split("/").pop();

  // Memoize categories to prevent re-calculation on every render
  const allCategories = useMemo(() => {
    return [
      ...new Set((blogs || []).flatMap((blog) => blog.categories || [])),
    ].sort();
  }, [blogs]);

  const handleCategoryChange = (category) => {
    if (category === "all") {
      router.push("/blog");
    } else {
      router.push(`/blog/category/${category}`);
    }
  };

  // Utility to convert slug to label
  const slugToLabel = (slug) => {
    return slug
      .replace(/-/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <div className="mb-8 overflow-x-auto pb-2 scrollbar-hide">
      <div className="flex gap-3 min-w-max relative">
        <button
          onClick={() => handleCategoryChange("all")}
          className={`px-6 py-2.5 rounded-full text-sm font-bold transition-all duration-300 relative cursor-pointer ${
            selectedCategory === "all"
              ? "text-white z-0"
              : "bg-white text-black border border-black/10 hover:border-black/40"
          }`}
        >
          {selectedCategory === "all" && (
            <motion.div
              layoutId="active-pill"
              className="absolute inset-0 bg-black rounded-full "
              style={{ zIndex: -1 }}
              transition={{ type: "spring", bounce: 0.15, duration: 0.5 }}
            />
          )}
          All Categories
        </button>

        {allCategories.map((category, index) => (
          <button
            key={index}
            onClick={() => handleCategoryChange(category)}
            className={`px-6 py-2.5 rounded-full text-sm font-bold transition-all duration-300 relative cursor-pointer ${
              selectedCategory === category
                ? "text-white z-0"
                : "bg-white text-black border border-black/10 hover:border-black/40"
            }`}
          >
            {selectedCategory === category && (
              <motion.div
                layoutId="active-pill"
                className="absolute inset-0 bg-black rounded-full "
                style={{ zIndex: -1 }}
                transition={{ type: "spring", bounce: 0.15, duration: 0.5 }}
              />
            )}
            {slugToLabel(category)}
          </button>
        ))}
      </div>
    </div>
  );
}
